import React from 'react';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Home />       {/* ✅ First Section */}
        <About />      {/* ✅ Now below Home */}
        <Services />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
